import React from 'react';
import './index.css'

function Index() {
    return <span className="spinner-loader"></span>
}

export default Index;